import React from "react";
import {
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  stepConnectorClasses,
  Typography,
  Box,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CheckIcon from "@mui/icons-material/Check";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

const steps = ["Set Up", "Link Bank Account", "Performance Overview", "Schedule Intro Call"];

const CustomConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: { top: 28 },
  [`& .${stepConnectorClasses.line}`]: {
    border: "none",
    borderTop: "2px dashed #FFFFFF",
    opacity: 0.9,
    margin: "0 8px",
    transition: "border-top 0.3s ease, background-color 0.3s ease",
  },
  [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
    borderTop: "2px solid #FFFFFF",
  },
  [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
    borderTop: "2px solid #FFFFFF",
  },
}));

const CustomStepIconRoot = styled("div")(({ bg }) => ({
  width: 56,
  height: 56,
  borderRadius: "50%",
  border: "2px solid white",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  backgroundColor: bg,
  zIndex: 2,
}));

function CustomStepIcon({ active, completed, icon, activeStep }) {
  let skipped = false;
  const stepIndex = icon - 1;

  if (!active && completed && stepIndex < activeStep) {
    if (stepIndex === 1 && localStorage.getItem("skipped_bank_setup") === "true") skipped = true;
    if (stepIndex === 2 && localStorage.getItem("skipped_performance_setup") === "true") skipped = true;
  }


  let bg = "transparent";
  if (skipped) bg = "#FFA500";
  else if (completed) bg = "#4CAF50";

  return (
    <CustomStepIconRoot bg={bg}>
      {completed ? (
        skipped ? (
          <AccessTimeIcon sx={{ color: "#FFFFFF", fontSize: 28 }} />
        ) : (
          <CheckIcon sx={{ color: "#FFFFFF", fontSize: 33 }} />
        )
      ) : active ? (
        <Box
          sx={{
            width: 26,
            height: 26,
            borderRadius: "50%",
            backgroundColor: "#FFFFFF",
          }}
        />
      ) : null}
    </CustomStepIconRoot>
  );
}

export const SetupStepper = ({ activeStep = 0 }) => {
  return (
    <Stepper
      activeStep={activeStep}
      alternativeLabel
      connector={<CustomConnector />}
      sx={{
        width: "100%",
        position: "relative",
        zIndex: 1,
        "& .MuiStep-root": { flex: "1 1 0", minWidth: 0 },
        "& .MuiStepLabel-label": { whiteSpace: "nowrap", fontSize: { xs: "0.8rem", sm: "1rem" } },
      }}
    >
      {steps.map((label, index) => (
        <Step key={label}>
          <StepLabel
            slots={{ stepIcon: CustomStepIcon }}
            slotProps={{ stepIcon: { activeStep } }}
            sx={{
              "& .MuiStepLabel-label": {
                color: "#FFFFFF",
                fontWeight: index <= activeStep ? 600 : 400,
              },
            }}
          >
            <Typography
              variant="body2"
              fontSize={"1rem"}
              fontWeight={500}
              sx={{ color: "#FFFFFF" }}
            >
              {label}
            </Typography>
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};
